




































import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import RoomTable from '@/components/RoomTable.vue';
import DashboardAnnonate from '@/components/DashboardAnnonate.vue';
import ModalBulkUpdate from '@/components/ModalBulkUpdate.vue';
import ModalMobileMessage from '@/components/ModalMobileMessage.vue';
import { mapGetters, mapState } from 'vuex';
import DoubleDatePicker from '@/components/DoubleDatePicker.vue';
import DateNavigation from '@/components/DateNavigation.vue';
import DropdownRoomStatus from '@/components/dropdowns/DropdownRoomStatus.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Welcome from '@/components/Welcome.vue';
import ApiError from '@/errors/ApiError';
import ServerError from '@/errors/ServerError';
import { DateRange } from 'moment-range';
import { UI_DAY_CELL_WIDTH, UI_CAPTION_COLUMN_WIDTH } from '@/utils/constants';
import ModalOnboard from '@/components/ModalOnboard.vue';
import ChannelManagerPromo from '@/components/ChannelManagerPromo.vue';
import { refreshWhatfix } from '@/utils/utils';

@Component({
    components: {
      RoomTable,
      DashboardAnnonate,
      DoubleDatePicker,
      DateNavigation,
      ModalBulkUpdate,
      ModalMobileMessage,
      DropdownRoomStatus,
      ErrorMessage,
      ModalOnboard,
      ChannelManagerPromo,
    },

    computed: {
      ...mapState(['dashboard', 'modals', 'partner']),
      ...mapGetters(['shouldShowOnboard']),
    },
  })

export default class Home extends Vue {
  get rooms() {
    return this.dashboard.roomList.sort((a: any, b: any) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });
  }

  get getErrorComponent() {
    if (this.errorCode === '202') {
      return Welcome;
    } else {
      return ErrorMessage;
    }
  }
  public dateRange: any = {
    start: null,
    end: null,
  };

  public errorCode: string = '';
  public lastActionTime: number = new Date().getTime();
  public isSmallView: boolean = false;
  public maxDays = this.$store.getters.maxDays;
  private readonly partner: any;
  private dashboard!: any;
  private shouldShowOnboard!: any;

  public updateDateRange(dateRange: DateRange) {
    if (moment(dateRange.end).isBefore(moment(dateRange.start))) {
      this.$store.dispatch('addToast', {
        type: 'error',
        title: 'errors.generic.title',
        message: 'errors.generic.description',
      });
      return;
    }

    this.$store.dispatch('getDashboardData', dateRange);
  }

  private beforeCreate() {
    if (this.$gtm.dataLayer() ) {
      this.$gtm.dataLayer().push({
        page_type: 'Calendar',
      });
    }
  }

  private async mounted() {
    if (!this.partner || !this.partner.token) {
      window.location.replace((process.env.VUE_APP_PMP_LOGIN_URL as string));
      return;
    } else {
      this.$store.commit('setPartnerId', this.partner.id);
    }
    this.dateRange = {
      start: moment().format('YYYY-MM-DD'),
      end: moment().add(this.$store.getters.initialDaysToDisplay, 'd').format('YYYY-MM-DD'),
    };
    this.$store.commit('updateDateRange', this.dateRange);
    try {
      await this.$store.dispatch('getPartnerDetails');
    } catch (error) {
      if (error instanceof ApiError) {
        this.errorCode = error.code || '000';
      }
      if (error instanceof ServerError) {
        this.$router.push({ path: '/error', query: {code: error.code || '000'} });
      }
    } finally {
      this.$store.commit('setLoadingState', false);
      if (this.shouldShowOnboard) { this.$store.dispatch('showModal', 'onboarding'); } else {
        (window as any).enableWhatfix = 'enabled';
        refreshWhatfix(this.partner.lang);
      }

      Vue.prototype.$PARTNER_HAS_VARIABLE_PRICING = this.partner.hasVariablePricing;
    }

    this.$gtm.trackEvent({
      event: 'manageYourAvailabilityPage',
    });

    window.addEventListener('touchstart', () => {
      this.lastActionTime = new Date().getTime();
    });
    window.addEventListener('click', () => {
      this.lastActionTime = new Date().getTime();
    });
    setTimeout(this.refresh, 15 * 60000);
  }

  // force a refresh if no action (click / touch) in the last 15 mins
  private refresh() {
    if (new Date().getTime() - this.lastActionTime >= 14 * 60000) {
      window.location.reload(true);
    } else {
      setTimeout(this.refresh, 15 * 60000);
    }
  }

    /**
     * on window resize:
     * - on resize up, do nothing
     * - on resize down, recalculate max days that can fit in the screen, update displayed end date
     *    and allowed number of days that can be selected in datepicker
     */
    @Watch('dashboard.windowWidth', {immediate: true})
    private onWindowWidthChange(newValue: number, oldValue: number) {
      this.maxDays = this.$store.getters.maxDays;
      if (newValue < oldValue) {
        const daysDisplayed = moment(this.dateRange.end).diff(moment(this.dateRange.start), 'days');
        if (UI_CAPTION_COLUMN_WIDTH + (UI_DAY_CELL_WIDTH * daysDisplayed) > newValue) {
          this.dateRange.end = moment(this.dateRange.start)
            .add(Math.floor((newValue - UI_CAPTION_COLUMN_WIDTH) / UI_DAY_CELL_WIDTH), 'days');
          this.updateDateRange(this.dateRange);
        }
      }
    }
  }
